import { FilterMatchMode } from 'primeng/api'

/**
 * Modo con el que arranca el filtro de una columna de la tabla genérica (F-008).
 *
 * PrimeNG arranca las columnas de texto en «Empieza con» y Operaciones busca casi siempre por un
 * pedazo del nombre o del folio («SUMMA», no «PROMOTORA DE…»). Solo cambia el texto —una columna sin
 * `type` es texto para PrimeNG—; fechas, números y sí/no conservan su modo, porque «contiene» no
 * significa nada sobre ellos. Devolver `undefined` deja que PrimeNG decida como antes.
 */
export function defaultFilterMatchMode(type: string | null | undefined): string | undefined {
  return !type || type === 'text' ? FilterMatchMode.CONTAINS : undefined
}

/**
 * Opciones del menú de un filtro de texto, con «Contiene» primero para que el modo inicial sea también
 * el primero que se lee. Son las seis que trae PrimeNG por omisión, solo reordenadas: quitar una
 * dejaría sin salida a quien hoy filtra con ella.
 */
export const TEXT_FILTER_MATCH_MODES: string[] = [
  FilterMatchMode.CONTAINS,
  FilterMatchMode.STARTS_WITH,
  FilterMatchMode.NOT_CONTAINS,
  FilterMatchMode.ENDS_WITH,
  FilterMatchMode.EQUALS,
  FilterMatchMode.NOT_EQUALS,
]
